<template>
  <div>
    <table class="table">
      <thead>
      <tr>
        <th>Name</th>
        <th>Options</th>
        <th>Last day before shipping</th>
        <th>Edit</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="month in months" :key="month.id">
        <td>{{ month.month_name }}</td>
        <td>
          <span v-if="editingMonth !== month.id">
              {{ month.month_parts }}
          </span>
          <span v-else>
              <input class="input" type="text" v-model="newMonthParts">
          </span>
        </td>
        <td width="20%">
          <span v-if="editingMonth !== month.id">
              {{ month.end_day }}
          </span>
          <span v-else>
              <input class="input" type="number" min="1" max="31" v-model="newEndDay">
          </span>
        </td>
        <td width="20%">
          <a @click="editMonth(month)" v-if="editingMonth !== month.id">Edit</a>
          <span v-else>
              <button type="button" class="button is-primary" @click="saveMonth()">Save</button>
              <a @click="stopEditing()">Cancel</a>
          </span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'months',
  data() {
    return {
      editingMonth: false,
      newMonthParts: null,
      newEndDay: null,
    }
  },
  computed: {
    ...mapGetters(['months'])
  },
  methods: {
    editMonth(month) {
      this.newMonthParts = month.month_parts
      this.newEndDay     = month.end_day
      this.editingMonth  = month.id
    },
    stopEditing() {
      this.editingMonth  = false;
      this.newMonthParts = null
      this.newEndDay     = null
    },
    saveMonth() {
      this.$store.dispatch("UPDATE_MONTH", {
        id: this.editingMonth,
        month_parts: this.newMonthParts,
        end_day: this.newEndDay,
      }).then(data => {
        this.stopEditing();
      }).catch(error => {
        this.stopEditing();
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Months.vue?0d3aa9fd